import {
	waitForTransactionReceipt,
	simulateContract,
	writeContract,
	getAccount,
} from "wagmi/actions";

import { getChainId, } from "wagmi/actions";

import * as contracts from "@contracts";
import { approve, } from "./approve";
import { allow,  } from "./allow";
import { getErrorResponse, n, } from "./helpers";
import { wagmiConfig } from "@config";
import { assertUserStaked, } from "./assertUserStaked";

import { lookupContractWithABI, type TokenDefinition, } from "@bracket/addressbook";
import type { ResolverResult, } from "./types";




export declare type DepositProps = {
	token: TokenDefinition;
	amount: bigint;
	attempt?: number;
}



export const deposit = async ({
	token,
	amount,
	attempt = 0,
}: DepositProps): Promise<ResolverResult> => {

	try {

		const allowedAmount = await allow({ token, contract: "Escrow", });
		if(allowedAmount < amount) {
			await approve({
				token,
				amount,
				contract: "Escrow",
				subcall: true,
			});
		}

		const chainId = await getChainId(wagmiConfig);
		const { address:wallet, } = getAccount(wagmiConfig);
		const [address, abi] = lookupContractWithABI(chainId as 1|42161, "Escrow");

		const { request, result, } = await simulateContract(wagmiConfig, {
			address,
			abi,
			functionName: "depositToken",
			args: [
				wallet,
				token.address,
				amount,
			]
		});
		if(result) {

			const hash = await writeContract(wagmiConfig, request);
			await assertUserStaked();
			return {
				status: "success",
				ok: true,
				message: "Your deposit was successful.",
				hash,
				code: "SUCCESS",
			}
		}
		throw new Error("simulation failed");
	}
	catch ( err ) {
		const response = getErrorResponse(err);
		const { retry, } = response;
		if( retry && attempt <= 3 ) {
			attempt++;
			return await deposit({ token, amount, attempt, });
		}
		return response;
	}

}
